var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardMembership(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140-443v103h680v-103H140Zm0-437h680q24.75 0 42.375 17.625T880-820v480q0 24.75-17.625 42.375T820-280H626v200l-146-74-146 74v-200H140q-24.75 0-42.375-17.625T80-340v-480q0-24.75 17.625-42.375T140-880Zm0 329h680v-269H140v269Zm0 211v-480 480Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMembership);
export default __webpack_public_path__ + "static/media/card_membership.5a6f467da01a777da097d87e0d8531f0.svg";
export { ForwardRef as ReactComponent };